import { ApiClient } from "@trigger.dev/core/v3"
import type {
	RealtimeClientOptions,
	RealtimeSubscriptionClient,
	RunWithStreamsEvent,
} from "./types"

const DEFAULT_API_URL = "https://api.trigger.dev"

function createApiClient(options: RealtimeClientOptions) {
	return new ApiClient(options.baseURL ?? DEFAULT_API_URL, options.accessToken)
}

export const defaultRealtimeClient: RealtimeSubscriptionClient = {
	subscribeToRun(runId, options) {
		return createApiClient(options).subscribeToRun(runId, {
			signal: options.signal,
			closeOnComplete: true,
		})
	},
	subscribeToRunsWithTag(tag, options) {
		return createApiClient(options).subscribeToRunsWithTag(tag, undefined, {
			signal: options.signal,
		})
	},
	subscribeToRunWithStreams(runId, options) {
		const subscription = createApiClient(options).subscribeToRun(runId, {
			signal: options.signal,
			closeOnComplete: true,
		})

		return {
			async *[Symbol.asyncIterator]() {
				try {
					for await (const event of subscription.withStreams()) {
						yield event as RunWithStreamsEvent
					}
				} finally {
					subscription.unsubscribe()
				}
			},
		}
	},
}
